/* Tatagaltier product card behaviour — build-spec §5.4, §5.8.
   - Inline variant switch: updates price + image + ATC target before Add to Cart.
     Unavailable variants are non-selectable (not hidden).
   - Wishlist heart: renders unfilled, fills on hydration from localStorage (never the reverse).
   AJAX add + drawer open is handled by Dawn's <product-form> element (cart_type: drawer). */

const TATA_WISHLIST_KEY = 'tata:wishlist';

function tataWishlistGet() {
  try { return JSON.parse(localStorage.getItem(TATA_WISHLIST_KEY)) || []; }
  catch { return []; }
}
function tataWishlistSet(list) {
  try { localStorage.setItem(TATA_WISHLIST_KEY, JSON.stringify(list)); } catch { /* private mode */ }
}

class TataCard extends HTMLElement {
  connectedCallback() {
    this.priceCurrent = this.querySelector('[data-tata-price-current]');
    this.priceCompare = this.querySelector('[data-tata-price-compare]');
    this.atcId = this.querySelector('[data-tata-atc-id]');
    this.atcButton = this.querySelector('.tata-card__atc');
    this.image = this.querySelector('.tata-card__image');

    this.querySelectorAll('[data-tata-variant]').forEach((btn) => {
      btn.addEventListener('click', () => this.selectVariant(btn));
    });

    this.hydrateWishlist();
    const heart = this.querySelector('[data-tata-wishlist]');
    if (heart) heart.addEventListener('click', () => this.toggleWishlist(heart));
  }

  selectVariant(btn) {
    if (btn.getAttribute('data-variant-available') !== 'true') return; // non-selectable
    this.querySelectorAll('[data-tata-variant]').forEach((b) => {
      b.classList.remove('is-selected');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-selected');
    btn.setAttribute('aria-pressed', 'true');

    this.scrollVariantIntoPeek(btn);

    if (this.atcId) this.atcId.value = btn.getAttribute('data-variant-id');
    if (this.priceCurrent) this.priceCurrent.textContent = btn.getAttribute('data-variant-price') || this.priceCurrent.textContent;
    if (this.priceCompare) {
      const cmp = btn.getAttribute('data-variant-compare');
      if (cmp) { this.priceCompare.textContent = cmp; this.priceCompare.hidden = false; }
      else this.priceCompare.hidden = true;
    }
    const img = btn.getAttribute('data-variant-image');
    if (img && this.image) { this.image.src = img; this.image.srcset = ''; }
  }

  // Snap the selected chip to the left; if it's too long, slide further so at least
  // half of the next chip stays visible (the "peek → advance" affordance).
  scrollVariantIntoPeek(btn) {
    const scroller = btn.parentElement;
    if (!scroller || scroller.scrollWidth <= scroller.clientWidth + 1) return;
    const chips = [...scroller.querySelectorAll('[data-tata-variant]')];
    const next = chips[chips.indexOf(btn) + 1];
    const sRect = scroller.getBoundingClientRect();
    const bRect = btn.getBoundingClientRect();
    const alignLeft = scroller.scrollLeft + (bRect.left - sRect.left); // selected chip to left edge
    let target = alignLeft;
    if (next) {
      const nRect = next.getBoundingClientRect();
      const nextMid = scroller.scrollLeft + (nRect.left - sRect.left) + nRect.width / 2;
      const revealHalfNext = nextMid - scroller.clientWidth; // half of next at the right edge
      target = Math.max(alignLeft, revealHalfNext);
    }
    const maxScroll = scroller.scrollWidth - scroller.clientWidth;
    scroller.scrollTo({ left: Math.max(0, Math.min(target, maxScroll)), behavior: 'smooth' });
  }

  hydrateWishlist() {
    const heart = this.querySelector('[data-tata-wishlist]');
    if (!heart) return;
    const handle = heart.getAttribute('data-product-handle');
    if (tataWishlistGet().includes(handle)) heart.setAttribute('aria-pressed', 'true');
  }

  toggleWishlist(heart) {
    const handle = heart.getAttribute('data-product-handle');
    const list = tataWishlistGet();
    const i = list.indexOf(handle);
    if (i === -1) { list.push(handle); heart.setAttribute('aria-pressed', 'true'); }
    else { list.splice(i, 1); heart.setAttribute('aria-pressed', 'false'); }
    tataWishlistSet(list);
    document.dispatchEvent(new CustomEvent('tata:wishlist:change', { detail: { handle, saved: i === -1 } }));
  }
}

if (!customElements.get('tata-card')) customElements.define('tata-card', TataCard);
